import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  getLocalStorage(): Storage | null {
    return this.isBrowser() ? localStorage : null;
  }

  getSessionStorage(): Storage | null {
    return this.isBrowser() ? sessionStorage : null;
  }

  getDocument(): Document | null {
    return this.isBrowser() ? document : null;
  }

  getWindow(): Window | null {
    return this.isBrowser() ? window : null;
  }
  getLocation(): Location | null {
    return this.isBrowser() ? location : null;
  }
}
